import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import Plus from '../../components/icons/Plus';

const CreateEventRow = () => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate('/event/create');
  }

  return <ContentContainer onClick={onClick}>
    <Plus color="#FFFFFF" size={150}/>
  </ContentContainer>
};


const ContentContainer = styled.div`
  justify-content: center;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 505px;
  cursor: pointer;
`;


export default CreateEventRow;
